import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  reason: string;
  invalidationMotivation?: string;
}

export const useInvalidateAllReleasedDeclarations = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, reason, invalidationMotivation }: HookProps) => {
      const result = await apiClient.idms.invalidateAll.mutation({ body: { reason, batchId, invalidationMotivation } });
      if (result.status !== 200) {
        throw result.body;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarations'] });
      toast.success('Invalidation request was sent!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending invalidation request!`);
    },
  });
};
